module.exports = __webpack_public_path__ + "263cc94bb3a2c15953d611a9d5ad8ccc.svg";